import { dayjs } from "@thalamos/common";

import { FormSectionSchema, type FormSection } from "../types/FormSection.js";
import {
  IncidentFormStatusSchema,
  IncidentFormTypeSchema,
  type IncidentFormType,
  type IncidentWorkItemWithContext,
} from "../types/incidentWorkItem.js";

function readRecordedDateTime(
  incident: IncidentWorkItemWithContext,
  formType: IncidentFormType,
  sectionId: FormSection,
  fieldName: string,
): string | undefined {
  const data = incident.forms
    .find(
      (f) =>
        f.status === IncidentFormStatusSchema.enum.active &&
        f.formType === formType,
    )
    ?.sections.find((s) => s.id === sectionId)?.data as
    Record<string, { value?: unknown } | null | undefined> | null | undefined;

  const value = data?.[fieldName]?.value;
  return typeof value === "string" && dayjs.utc(value).isValid()
    ? value
    : undefined;
}

/**
 * When police left the place of safety (ISO 8601): the time given on finishing the
 * incident, otherwise the time given when it was ended early. `undefined` when neither
 * records one.
 */
export function getPoliceLeftDateTime(
  incident: IncidentWorkItemWithContext,
): string | undefined {
  return (
    readRecordedDateTime(
      incident,
      IncidentFormTypeSchema.enum.finishForm,
      FormSectionSchema.enum.finishForm,
      "dateTimeLeft",
    ) ??
    readRecordedDateTime(
      incident,
      IncidentFormTypeSchema.enum.preEndIncident,
      FormSectionSchema.enum.preEndIncident,
      "leavePos",
    )
  );
}
